<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<style>
  html, body,
  #app {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    border: 0;
    vertical-align: baseline;
  }
</style>
